module.exports = __webpack_public_path__ + "img/pazar-sanati.61c95f8d.jpg";